export enum SlugStatus {
    FROM_REDIRECT_AND_UPDATE_REPLACE_EXISTS = "FROM_REDIRECT_AND_UPDATE_REPLACE_EXISTS",
    FROM_REDIRECT_EXISTS = "FROM_REDIRECT_EXISTS",
    UPDATE_REPLACE_EXISTS = "UPDATE_REPLACE_EXISTS",
    NO_CONFLICTS = "NO_CONFLICTS"
  }